'use strict';
import $ from 'jquery';

export default class Wiki {
    categories = [];
    base = '';
    page = 1;
    link = false;
    clearCache = false;
    searchTerm = false;

    static init() {
        if ($('#wiki-content').length > 0) {
            new Wiki();
        }
    }

    constructor() {
        this.el = $('#wiki-content');
        this.base = this.el.data('base');
        this.el.on('click', '.resources-pagination a.page-numbers', this.onClick.bind(this));
        $('.drop-down-button').on('click', this.dropDownToggleEvent.bind(this));
        $('.category-input').on('click', this.filterByCategory.bind(this));
        $('.wiki-search-form').on('submit', this.onSearch.bind(this));

        const params = new URLSearchParams(window.location.search);
        if (params.has("clearCache")) {
            this.clearCache = true;
        }


    }

    onSearch(e) {
        e.preventDefault();
        const search_term = $('.wiki-search-form input').val();
        this.searchTerm = search_term;
        this.updateDisplay();
    }

    onClick(e) {
        e.preventDefault();
        this.page = $(e.currentTarget).text();
        this.link = $(e.currentTarget);
        this.updateDisplay();
    }

    updateDisplay() {
        const self = this;
        const data = {
            action: 'display_wiki',
            paged: this.page,
            base: this.base,
            categories: this.categories,
        };
        if (false !== this.searchTerm) {
            data.search_term = this.searchTerm;
        }
        if (true === this.clearCache)
            data.clear_cache = true;

        $.ajax({
            url: window.dremioJs.ajaxUrl,
            method: 'POST',
            dataType: 'json',
            data: data,
            success: (results) => {
                // console.log("result: ", results);
                if (true === results.no_results) {
                    this.el.find('.resources-list').html('');
                    this.el.find('.resources-pagination').html('');
                    this.el.find('.no-results').show();
                } else {
                    this.el.find('.no-results').hide();
                    this.el.find('.resources-list').html(results.results);
                    this.el.find('.resources-pagination').html(results.pagination);
                    if (this.link && this.categories.length === 0)
                        window.history.pushState({}, "", this.link.attr('href'));
                }
                $('html, body').animate({
                    scrollTop: self.el.offset().top - $('nav.navbar').outerHeight()
                }, 800);
            },
        })
    }

    filterByCategory(e) {
        this.link = false;
        this.page = 1;
        this.categories = [];
        $('.category-input').each((i, el) => {
            if ($(el).is(':checked')) {
                this.categories.push($(el).data('category-slug'));
            }
        });
        // console.log("categories: ", this.categories);
        this.updateDisplay();
        window.history.pushState({}, false, this.base);
    }

    dropDownToggleEvent(event) {
        let button = $(event.target).parent().closest('.drop-down-button');
        if (!button.is(button)) {
            button = $(event.target)
        }
        this.dropDownToggle(button);
    }

    dropDownToggle(button) {
        let parentEl = button.parent().closest('.checkboxes-filter');
        let children = parentEl.find('> .checkboxes-filter');
        let is_expand = button.data('active');
        let bi = button.find('.bi');
        if (!is_expand) {
            children.removeClass('d-none');
            bi.removeClass('bi-chevron-down');
            bi.addClass('bi-chevron-up');
            button.data('active', true);
        } else {
            children.addClass('d-none');
            bi.removeClass('bi-chevron-up');
            bi.addClass('bi-chevron-down');
            button.data('active', false);
        }
    }
}